import script from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=bee77fc4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bee77fc4"]])

export default __exports__